export default "__VITE_ASSET__CMeyL1Oy__"